module.exports = __webpack_public_path__ + "img/tutor-eval.f18727d1.svg";